module.exports = __webpack_public_path__ + "static/media/carfixio-1.620ee42b.jpg";